import { BaseRequest } from './BaseRequest';

export class TileRequest extends BaseRequest {
  tileX;
  tileY;
  width;
  height;
  zoom;
  pixelX;
  pixelY;

  constructor (tileX, tileY, width, height, zoom) {
    super();
    this.tileX = tileX;
    this.tileY = tileY;
    this.width = width;
    this.height = height;
    this.zoom = zoom;
    this.pixelX = tileX * width;
    this.pixelY = tileY * height;

    this.position = `${tileX},${tileY}`;
  }

  getUrl (builder) {
    return builder.region(this.pixelX, this.pixelY, this.width, this.height, this.zoom);
  }
}
